import $ from 'jquery';

import { moydomHeader } from 'navigations';

$(() => {
    moydomHeader.run();
    moydomHeader.counter.TYPES = {
        NOTIFICATION: 'notification',
        HOUSE: 'house',
    };
});

export default moydomHeader;
